import { ReactNode } from 'react';

/**
 * Left nest rail under StickySectionHeading (nested).
 * Full-height vertical line; the sticky join’s opaque fill covers the top while
 * stuck so the square edge never shows through the rounded corner.
 */
export default function NestedSectionRail({ children }: { children: ReactNode }) {
  return (
    <div className="relative z-0 pl-6 pt-2">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 left-0 border-l border-gray-200"
      />
      {/* Tight stack under the sticky join: body → cards → child sections */}
      <div className="relative space-y-3">{children}</div>
    </div>
  );
}
